module.exports = __webpack_public_path__ + "static/media/img1.92e0b2e8.png";